import React, { useEffect, useState, useRef } from "react";
import Imgix from "react-imgix";
import webpfy from "webpfy";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import common components
import Typography, { TYPE_ELEMENTS } from "./Typography";

const BannerElement = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  max-width: 100%;
  height: 540px;

  @media (max-width: 1400px) {
    height: 480px;
  }

  @media (max-width: 1280px) {
    height: 400px;
  }

  @media (max-width: 1024px) {
    height: 360px;
  }

  @media (max-width: 768px) {
    height: 300px;
  }

  @media (max-width: 480px) {
    height: 249px;
  }
`;

const BannerImg = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  aspect-ratio: 32/9;
  object-fit: cover;
  opacity: ${({ opacity }) => opacity};
`;

const BannerHeader = styled.div`
  position: relative;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 90%;
  height: fit-content;
  text-align: center;
`;

export default function Banner({
  img = "",
  alt = "",
  headers = [""],
  opacity = 1,
}) {
  const [webpImg, setWebpImg] = useState(null);
  const bannerElementRef = useRef(null);
  const bannerImgWrapperRef = useRef(null);
  
  return (
    <BannerElement className="banner-element" ref={bannerElementRef}>
      <BannerImg class="lazyload"
        src={`${img}?w=1600&auto=format,compress`}
        className="banner-img"
        opacity={opacity}
        fetchpriority="high"
        loading={"eager"}
        alt={alt}
        sizes="100vw"
        srcSet={[
          `${img}?w=480&auto=format,compress 480w`,
          `${img}?w=768&auto=format,compress 768w`,
          `${img}?w=1024&auto=format,compress 1024w`,
          `${img}?w=1280&auto=format,compress 1280w`,
          `${img}?w=1400&auto=format,compress 1400w`,
          `${img}?w=1600&auto=format,compress 1600w`
        ].join(', ')}
      />
      <BannerHeader className="banner-header">
        {headers.map((header, i) => (
          <Typography
            typeElement={TYPE_ELEMENTS.H_2}
            customColor={!i && headers.length > 1 ? "#FF4F00" : ""}
            customCase="uppercase"
          >
            {header}
          </Typography>
        ))}
      </BannerHeader>
    </BannerElement>
  );
}
